module.exports = __webpack_public_path__ + "img/staymasked-logo.a3209911.svg";